import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-upselling',
    template: require('./upselling.component.html'),
    styles: []
})
export class UpsellingComponent implements OnInit {
    private columnDefs;
    private rowData;
    private rowHeight;

    constructor() {
        this.columnDefs = [
            {
                headerName: 'Action', field: 'action', width: 100, pinned: 'left', cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = `
            <div class="grid_actions">
                <span class="grid_actions_item viewBtn"><i class="icon-edit"></i></span>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1">
                    <label class="custom-control-label" for="customCheck1"></label>
                </div>
            </div>
            `;
                    return eDiv;
                }
            },
            { headerName: 'Scheme Typename', field: 'schemename', width: 300 },
            { headerName: 'Upselling Name', field: 'upselling',  width: 150 },
            { headerName: 'Start Date', field: 'startdate', width: 120 },
            { headerName: 'End Date', field: 'enddate', width: 120 },
            { headerName: 'Product', field: 'product', width: 200 },
            { headerName: 'Comapny', field: 'company', width: 120 },
            { headerName: 'Selling Type', field: 'sellingtype', width: 150 },
            { headerName: 'Minimum Quantity', field: 'minqty', width: 170 },
            { headerName: 'Selling Offer', field: 'selligoffer', width: 150 },

        ];

        this.rowData = [
            { schemename: 'Children Nebulizer', upselling: 'Custom', startdate: '09-10-2019', enddate: '30-04-2020', product: 'INFANT MASK', company: 'active', sellingtype: 'selling discount', minqty: 10, selligoffer: 2 },
            { schemename: 'N95 PM 2.5 Pollution mask', upselling: 'Product',  startdate: '09-10-2019', enddate: '19-11-2020', product: 'Faridabad', company: 'Active', sellingtype: 'selling discount', minqty: 10, selligoffer: 2 },
            { schemename: 'NON CONTACT INFRA RED BODY THERMOMETER', upselling: 'Product', startdate: '09-10-2019', enddate: '30-04-2020', product: 'NON CONTACT INFRA RED BODY THERMOMETER',  company: 'active',sellingtype: 'selling discount', minqty: 10, selligoffer: 2 },
        ];
        this.rowHeight = 50;
    }



    ngOnInit() {
    }

}
